<div class="box-widget-item fl-wrap block_box" *ngIf="!alert">
    <div class="box-widget-item-header">
        <h3>Working Hours</h3>
    </div>
    <div class="box-widget opening-hours fl-wrap">
        <div class="box-widget-content">
            <ul class="no-list-style">
                <li class="mon"><span class="opening-hours-day">Monday </span><span class="opening-hours-time">{{businessTime.dt_Monday}}</span></li>
                <li class="tue"><span class="opening-hours-day">Tuesday </span><span class="opening-hours-time">{{businessTime.dt_Tuesday}}</span></li>
                <li class="wed"><span class="opening-hours-day">Wednesday </span><span class="opening-hours-time">{{businessTime.dt_Wednesday}}</span></li>
                <li class="thu"><span class="opening-hours-day">Thursday </span><span class="opening-hours-time">{{businessTime.dt_Thursday}}</span></li>
                <li class="fri"><span class="opening-hours-day">Friday </span><span class="opening-hours-time">{{businessTime.dt_Friday}}</span></li>
                <li class="sat"><span class="opening-hours-day">Saturday </span><span class="opening-hours-time">{{businessTime.dt_Saturday}}</span></li>
                <li class="sun"><span class="opening-hours-day">Sunday </span><span class="opening-hours-time">{{businessTime.dt_Sunday}}</span></li>
            </ul>
        </div>
    </div>
</div> 